import { useNavigate, useLocation } from 'react-router-dom';
import type { NavigationAdapter } from 'nextstepjs';

/**
 * React Router Navigation Adapter for NextStep
 * Allows NextStep to work with React Router v6
 */
export const useReactRouterAdapter = (): NavigationAdapter => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path: string) => {
      navigate(path);
    },
    getCurrentPath: () => {
      return location.pathname;
    },
  };
};
